export default __webpack_public_path__ + "scene1_3_bg9bb250.png";